<template>
  <tr>
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal" />
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal" />
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal">
      {{ $t("common.quantity") }}
    </th>
    <th class="bg-corepla-bg-dark text-white text-xs py-1 font-normal">
      {{ $t("auction.effective_price") }}
    </th>
    <th
      v-if="auction.auctionStatus == 'REDISTRIBUTING_1' || auction.auctionStatus == 'REDISTRIBUTING_2'"
      class="bg-corepla-bg-dark text-white text-xs py-1 font-normal hidden md:table-cell"
    >
      {{ $t("lot.preempt") }}
    </th>
    <th
      v-if="auction.auctionStatus == 'CLOSED'"
      class="bg-corepla-bg-dark text-white text-xs py-1 font-normal hidden md:table-cell"
    />
  </tr>
</template>

<script setup>
const props = defineProps({
    auction: {
        type: Object,
        required: true
    }
})
</script>